/* linguist-generated */
/* eslint-disable */
// Generated code. Do not modify.
// To add additional endpoints, please add them to your api-gateway protos and
// re-run yarn nx run instant-api-hooks-<module>:codegen
//
import { useCallback } from 'react';
import { getBaseUrl } from '../../Account-managementApiEnvironment';

import {
  useFetchableResource,
  useGetResource,
  useFetch,
  FetchOptions,
  FetchSkippableOptions,
  FetchNonThrowingOverloadOptions,
} from '@cbhq/instant-api-hooks-core/fetch';
import { CONSOLE_PREFIX, CONSOLE_STYLE } from '@cbhq/instant-api-hooks-core/util';

import {
  CoinbaseEngUsersAccountManagementApiApiGetRoleDefinitionsResponse,
  getCoinbaseEngUsersAccountManagementApiApiGetRoleDefinitionsResponseErrors,
} from '../../types/coinbase/eng/users/account_management/api/api/CoinbaseEngUsersAccountManagementApiApiGetRoleDefinitionsResponse';

export type RoleDefinitionsArgs = {
  /**
   * optional filter by specific product IDs (e.g., ["retail", "cdp"]).
   */
  productIds?: string[];

  /**
   * optional organization ID used to gate role visibility per organization (e.g. coinbiz roles).
   */
  organizationId?: string;
};

export type RoleDefinitionsResult =
  CoinbaseEngUsersAccountManagementApiApiGetRoleDefinitionsResponse;

const validateRoleDefinitionsResult = (value: unknown) => {
  const errors = getCoinbaseEngUsersAccountManagementApiApiGetRoleDefinitionsResponseErrors(value);
  if (errors.length) {
    console.error(
      CONSOLE_PREFIX,
      CONSOLE_STYLE,
      `API Error: RoleDefinitionsResult data does not match contract.`,
      errors,
    );
  }
};

export const getRoleDefinitionsUrl = (
  params: RoleDefinitionsArgs,
  {
    additionalParams,
    baseUrl,
  }: {
    additionalParams?: Record<string, unknown>;
    baseUrl?: string;
  } = {},
) => {
  const searchParams = new URLSearchParams();
  if (params.productIds !== null && params.productIds !== undefined) {
    const val = params.productIds;
    Array.isArray(val) && val.forEach((_) => searchParams.append('product_ids', _));
  }

  if (params.organizationId !== null && params.organizationId !== undefined) {
    const val = params.organizationId;
    searchParams.append('organization_id', `${val}`);
  }

  if (additionalParams) {
    for (const [key, value] of Object.entries(additionalParams)) {
      if (value !== null && value !== undefined && !searchParams.has(key)) {
        searchParams.append(key, `${value}`);
      }
    }
  }
  const url = `${baseUrl || getBaseUrl()}/organization/v1/role-definitions${
    searchParams.toString() === '' ? '' : `?${searchParams}`
  }`;
  return url;
};

/**
 * Fetch RoleDefinitions
 * @Url /organization/v1/role-definitions
 * @Auth Required
 */

export function useGetRoleDefinitions(
  params: RoleDefinitionsArgs,
  options: FetchSkippableOptions | FetchNonThrowingOverloadOptions,
): RoleDefinitionsResult | undefined;

export function useGetRoleDefinitions(
  params: RoleDefinitionsArgs,
  options?: FetchOptions,
): RoleDefinitionsResult;

export function useGetRoleDefinitions(
  params: RoleDefinitionsArgs,
  options?: FetchOptions | FetchSkippableOptions | FetchNonThrowingOverloadOptions,
) {
  const url = getRoleDefinitionsUrl(params, options);
  const data = useFetch<RoleDefinitionsResult>({ url, ...options });

  if (process.env.NODE_ENV !== 'production') {
    validateRoleDefinitionsResult(data);
  }

  return data;
}

/**
 * Access RoleDefinitions fetch callback
 */
export const useGetRoleDefinitionsCallback = () => {
  const getResource = useGetResource();

  const fetch = useCallback(
    async (params: RoleDefinitionsArgs, additionalHeaders?: Record<string, string>) => {
      const url = getRoleDefinitionsUrl(params);
      const resource = getResource<RoleDefinitionsResult>(url, undefined, additionalHeaders);

      await resource.fetch();
      const data =
        resource.data == null
          ? new Error('FetchableResource completed but no data or error was set')
          : resource.data;

      if (process.env.NODE_ENV !== 'production') {
        validateRoleDefinitionsResult(data);
      }

      return data;
    },
    [getResource],
  );

  return fetch;
};

/**
 * Refresh RoleDefinitions without throwing to suspense
 * @Url /organization/v1/role-definitions
 * @Auth Required
 */
export const useRefreshRoleDefinitions = (
  params: RoleDefinitionsArgs,
  additionalParams: {
    disableCamelize?: boolean;
    additionalHeaders?: Record<string, string>;
  } = {},
) => {
  const { disableCamelize, additionalHeaders } = additionalParams;
  const url = getRoleDefinitionsUrl(params);

  const { fetch } = useFetchableResource<RoleDefinitionsResult>(
    url,
    disableCamelize,
    additionalHeaders,
  );

  return fetch;
};

/**
 * Remove RoleDefinitions from cache without refetching. Subscribed components may refresh and throw to suspense.
 * @Url /organization/v1/role-definitions
 */
export const useClearRoleDefinitions = (params: RoleDefinitionsArgs) => {
  const url = getRoleDefinitionsUrl(params);

  const { clear } = useFetchableResource<RoleDefinitionsResult>(url);

  return clear;
};

export const useWithOptimisticRoleDefinitionsUpdates = (params: RoleDefinitionsArgs) => {
  const url = getRoleDefinitionsUrl(params);

  const { optimisticUpdate } = useFetchableResource<RoleDefinitionsResult>(url);

  return optimisticUpdate;
};
